import {
	Button,
	Grid,
	FormControl,
	FormLabel,
	IconButton,
	FormHelperText,
	TextField,
} from '@mui/material';
import React, { FC, useCallback, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { StudentsInterface } from '../../interfaces';
import { useTranslation } from '../../services';
import { Student } from '../Student';
import DeleteIcon from '@mui/icons-material/Delete';

const Students: FC<StudentsInterface> = ({
	control,
	error,
	label,
	helperText,
	listOfStudents,
	setListOfStudents,
}) => {
	const { t } = useTranslation();
	const { fields, append, update, remove } = useFieldArray({
		control,
		name: 'students',
		keyName: 'uiId',
	});

	const addStudent = useCallback(() => {
		append({ name: '', email: '' });
	}, [append]);

	const [listOfStudentsError, setListOfStudentsError] = useState<boolean>(false);

	const addStudents = useCallback(() => {
		if (listOfStudents.length > 0) {
			let students = listOfStudents;
			const list = listOfStudents.split('\n')
			list.forEach((student, i) => {
				let email: RegExpMatchArray | null | string = student.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
				email = email ? email[0] : '';
				if(email){
					const name = student.replace(email, '').replace(/[$&+,:;=?#|'<>^*()%!]/gi, '').trim();
					append({ name, email: email.replace(/\s/, '') });
					students = students.replace(`${student}${i === list.length-1 ? '' : '\n'}`, '');
				}
			});
			setListOfStudents(students || '');
			setListOfStudentsError(!!students);
		}
	}, [listOfStudents, setListOfStudents, append]);

	const listOfStudentsChangeHandler = useCallback(
		(e: any) => {
			setListOfStudents(e.target.value);
			setListOfStudentsError(false);
		},
		[setListOfStudents, setListOfStudentsError]
	);

	return (
		<FormControl
			sx={{ border: 1, borderRadius: 1, p: 3, boxSizing: 'border-box' }}
			fullWidth
			required
			error={error}
			component="fieldset"
			variant="outlined"
		>
			<FormLabel component="legend" sx={{ p: '5px' }}>
				{label}:
			</FormLabel>
			<Grid item container xs={12} spacing={2}>
				{fields.map((field, index) => (
					<Grid key={field.uiId} item container xs={12} spacing={2}>
						<Grid item container xs={10} spacing={2}>
							<Student
								index={index}
								control={control}
								update={update}
								value={field as any}
								error={error}
							/>
						</Grid>
						<Grid item xs={1}>
							<IconButton
								key={`remove_${field.uiId}`}
								type="button"
								style={{marginTop: "8px"}}
								title={t('Remove student')}
								onClick={() => {
									remove(index);
								}}
							>
								<DeleteIcon />
							</IconButton>
						</Grid>
					</Grid>
				))}
				<Grid item xs={12}>
					<FormHelperText>{helperText}</FormHelperText>
				</Grid>
				<Grid item xs={12} sm={5} md={4}>
					<Button variant="contained" type="button" onClick={addStudent}>
						{t('Add New Student')}
					</Button>
				</Grid>
				<Grid container item xs={12} spacing={2}>
					<Grid item xs={12} sm={5} md={4}>
						<Button variant="contained" type="button" onClick={addStudents}>
							{t('Add New Students')}
						</Button>
					</Grid>
					<Grid item xs={12} sm={7} md={8}>
						<TextField
							fullWidth
							error={listOfStudentsError}
							label={t('Add list of students')}
							value={listOfStudents}
							onChange={listOfStudentsChangeHandler}
							placeholder={`Іван Франко, ivan.franko@lit.ua,
Леся Українка, lesya.ukr@test.com`}
							title={t('Add list of students')}
							helperText={t(
								'If you need to add many students you can add list of students to this field. One student - one line. Format: Full Name, Email'
							)}
							multiline
						/>
					</Grid>
				</Grid>
			</Grid>
		</FormControl>
	);
};
export default Students;
